export { useShallowSelector } from '../../../hooks';

export const partnerNameSelector = (opportunityId) => ({ entities: { opportunities } }) => (
  opportunities.byId[opportunityId]?.partnerName
);
